import monaco from 'monaco-editor';
import { observable, action, makeObservable } from 'mobx';
import { h5JsApi, loadScript } from '~/utils';
import { STATIC_ASSETS_PATH_PREFIX } from '~/constants/common';

export type Monaco = typeof monaco;
export type * from 'monaco-editor';

const loadMonaco = (): Promise<Monaco | undefined> => {
    const editorAssetsPath = `${window.jdy_config.assets_endpoint}${STATIC_ASSETS_PATH_PREFIX}/${MONACO_DIR}`;
    return new Promise((resolve) => {
        loadScript(editorAssetsPath + '/loader.js', () => {
            try {
                // 这里的require是amd的require
                const amdRequire: any = window.require;
                amdRequire.config({
                    paths: {
                        vs: editorAssetsPath
                    }
                });
                // 只需要手动加载editor.main，剩下的让编辑器动态加载
                amdRequire(['vs/editor/editor.main'], () => {
                    // @ts-ignore
                    // amd方式引入的monaco存储于window中
                    resolve(window.monaco as Monaco);
                });
            } catch (err) {
                resolve(undefined);
            }
        });
    });
};

class MonacoEditor {
    monaco?: Monaco;
    isLoading = true;
    constructor() {
        makeObservable(this, {
            monaco: observable.ref,
            isLoading: observable,
            setMonaco: action,
            setLoading: action
        });

        /**
         * MonacoEditor 初始化时就 loadMonaco 的话，会导致其中的脚本逻辑和 jssdk 脚本的异步加载逻辑相冲突导致报错
         * 所以需要确保 jssdk 脚本加载完成再 loadMonaco
         * @see https://project.feishu.cn/b2rl2h/issue/detail/6683683938
         */
        h5JsApi.loaded(() => {
            loadMonaco().then((m) => {
                this.setLoading(false);
                this.setMonaco(m);
            });
        });
    }

    setMonaco(monaco?: Monaco) {
        this.monaco = monaco;
    }
    setLoading = (isLoading: boolean) => {
        this.isLoading = isLoading;
    };
}

// 使用单例模式，避免多次构造
export const monacoStore = new MonacoEditor();
